module.exports = __webpack_public_path__ + "static/img/2_1_1_1.dfe9db31.jpg";